module.exports = __webpack_public_path__ + "static/media/leftArrow.a0e67960.svg";